// extracted by mini-css-extract-plugin
module.exports = {"backBtn":"styles_backBtn__2Cmpp"};